'use client';
import React, { useState } from 'react';

interface GalleryImage {
  src: string;
  alt: string;
  category: string;
  caption: string;
}

const galleryImages: GalleryImage[] = [
{
  src: '/assets/images/20230707_123056-1785082437414.jpg',
  alt: 'Morocco Jewish heritage tour group visiting a historic site',
  category: 'Tour Photos',
  caption: 'Heritage Tour'
},
{
  src: '/assets/images/20230221_131232-1785082456513.jpg',
  alt: 'Morocco Jewish tour participants exploring a traditional site',
  category: 'Tour Photos',
  caption: 'Tour Experience'
},
{
  src: '/assets/images/20230221_131058-1785082482746.jpg',
  alt: 'Guests on a Morocco Jewish heritage tour discovering local culture',
  category: 'Tour Photos',
  caption: 'Cultural Discovery'
},
{
  src: '/assets/images/20230221_125830-1785082504710.jpg',
  alt: 'Morocco Jewish tour group at a historic Jewish quarter',
  category: 'Tour Photos',
  caption: 'Jewish Quarter Visit'
},
{
  src: '/assets/images/20230221_125830-1785082519455.jpg',
  alt: 'Tour participants experiencing Moroccan Jewish heritage sites',
  category: 'Tour Photos',
  caption: 'Jewish Heritage'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1cac2fd04-1765111002310.png",
  alt: 'Marrakech Djemaa el-Fna square at sunset with traditional Moroccan architecture and street performers',
  category: 'Cities',
  caption: 'Marrakech'
},
{
  src: 'https://img.rocket.new/generatedImages/rocket_gen_img_1859c427a-1773101492246.png',
  alt: 'Sahara Desert golden sand dunes at sunrise with camel silhouettes in Morocco',
  category: 'Desert',
  caption: 'Sahara Desert'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1f26d3a45-1772730080299.png",
  alt: 'Chefchaouen blue painted streets and doorways in the Rif Mountains of northern Morocco',
  category: 'Cities',
  caption: 'Chefchaouen'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1686a4766-1776644732132.png",
  alt: 'Hassan II Mosque in Casablanca with ocean backdrop and towering minaret at dusk',
  category: 'Heritage',
  caption: 'Casablanca'
},
{
  src: "https://images.unsplash.com/photo-1662260648241-968507898421",
  alt: 'Atlas Mountains landscape with snow-capped peaks and traditional Berber village in Morocco',
  category: 'Nature',
  caption: 'Atlas Mountains'
},
{
  src: "https://images.unsplash.com/photo-1654109317799-89e1872e095e",
  alt: 'Moroccan desert camp at night with stars and traditional Berber tents under the Milky Way',
  category: 'Desert',
  caption: 'Desert Camp'
},
{
  src: "https://images.unsplash.com/photo-1545609494-957a67bfde99",
  alt: 'Essaouira blue and white medina walls with Atlantic Ocean and colorful fishing boats',
  category: 'Coastal',
  caption: 'Essaouira'
},
{
  src: "https://images.unsplash.com/photo-1620621625092-2ae11765fe68",
  alt: 'Fes ancient medina tanneries with colorful dye vats and leather workers in Morocco',
  category: 'Heritage',
  caption: 'Fes Tanneries'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1a7e4a4f8-1783858393331.png",
  alt: 'Traditional Moroccan riad courtyard with central fountain and intricate mosaic tile work',
  category: 'Culture',
  caption: 'Moroccan Riad'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1330c258e-1785077200969.png",
  alt: 'Historic Jewish synagogue interior in Morocco with ornate Moorish decorations and Star of David',
  category: 'Jewish Heritage',
  caption: 'Historic Synagogue'
},
{
  src: 'https://img.rocket.new/generatedImages/rocket_gen_img_1db69a226-1785070341912.png',
  alt: 'Volubilis Roman ruins with triumphal arch and ancient mosaic floors in Morocco',
  category: 'Heritage',
  caption: 'Volubilis Ruins'
},
{
  src: 'https://img.rocket.new/generatedImages/rocket_gen_img_1a234905a-1772222832420.png',
  alt: 'Moroccan souk market with colorful spices, hanging lanterns, and traditional crafts',
  category: 'Culture',
  caption: 'Moroccan Souks'
}];


const categories = ['All', 'Tour Photos', 'Cities', 'Desert', 'Heritage', 'Jewish Heritage', 'Nature', 'Coastal', 'Culture'];

export default function Gallery() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightboxImage, setLightboxImage] = useState<GalleryImage | null>(null);

  const filtered =
  activeCategory === 'All' ?
  galleryImages :
  galleryImages.filter((img) => img.category === activeCategory);

  return (
    <section id="gallery" className="section-padding bg-white">
      <div className="container-luxury">
        {/* Header */}
        <div className="text-center mb-12 animate-on-scroll">
          <span className="tag-gold">Gallery</span>
          <h2 className="section-title mt-4 mb-4">
            Morocco Through
            <br />
            <span className="text-gold italic">Our Lens</span>
          </h2>
          <div className="gold-divider" />
          <p className="section-subtitle mx-auto mt-4">
            A visual journey through Morocco&apos;s most breathtaking landscapes, ancient cities,
            and cultural treasures.
          </p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-2 mb-10 animate-on-scroll">
          {categories.map((cat) =>
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`font-sans text-xs font-bold uppercase tracking-wider px-4 py-2 border transition-all duration-300 ${
            activeCategory === cat ?
            'bg-gold text-navy-dark border-gold' : 'bg-white text-navy border-gray-200 hover:border-gold hover:text-gold'}`
            }>
            
              {cat}
            </button>
          )}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {filtered.map((image, index) =>
          <div
            key={`${image.caption}-${index}`}
            className={`gallery-item animate-on-scroll ${
            index === 0 || index === 5 ? 'md:col-span-2 md:row-span-2' : ''}`
            }
            style={{ transitionDelay: `${index % 4 * 60}ms` }}
            onClick={() => setLightboxImage(image)}>
            
              <div
              className={`relative overflow-hidden ${
              index === 0 || index === 5 ? 'h-64 md:h-full min-h-[300px]' : 'h-48 md:h-56'}`
              }>
              
                <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy" />
              
                <div className="absolute inset-0 bg-navy-dark/0 group-hover:bg-navy-dark/50 transition-all duration-300" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="text-center">
                    <svg className="w-8 h-8 text-white mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                    </svg>
                    <span className="font-sans text-xs text-white uppercase tracking-wider">{image.caption}</span>
                  </div>
                </div>
                {/* Category Tag */}
                <div className="absolute bottom-3 left-3">
                  <span className="font-sans text-xs font-bold uppercase tracking-wider px-2 py-1 bg-gold text-navy-dark">
                    {image.category}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Lightbox */}
        {lightboxImage &&
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setLightboxImage(null)}>
          
            <div className="relative max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
              <img
              src={lightboxImage.src}
              alt={lightboxImage.alt}
              className="w-full max-h-[80vh] object-contain" />
            
              <div className="absolute bottom-0 left-0 right-0 bg-navy-dark/80 p-4">
                <p className="font-serif text-white text-center">{lightboxImage.caption}</p>
                <p className="font-sans text-xs text-gold/80 text-center mt-1">{lightboxImage.category}</p>
              </div>
              <button
              onClick={() => setLightboxImage(null)}
              className="absolute -top-12 right-0 text-white hover:text-gold transition-colors duration-200"
              aria-label="Close lightbox">
              
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        }
      </div>
    </section>);

}